import { Button, Modal } from "react-bootstrap";

import './DeleteVideoModal.scss';

const DeleteVideoModal = ({
        show,
        deleteVideoHandler,
        deleteVideoData
    }) => {

    return (
        <>
            {/* <Modal
                show={show}
                size="lg"
                centered
                className="delete-video-modal"
            >   
                <Modal.Body className="delete-video-modal-body">
                    <h2 className="delete-video-header">Delete Video</h2>
                    <p className="delete-video-content">Are you sure you want to delete this Video ?</p>
                </Modal.Body>
                <Modal.Footer className="delete-video-footer">
                    <Button onClick={() => deleteVideoHandler('No', '')} className="delete-video-confirmation-no">
                        CANCEL
                    </Button>
                    <Button onClick={() => deleteVideoHandler('Yes', '')} className="delete-video-confirmation-yes">
                        DELETE
                    </Button>
                </Modal.Footer>
            </Modal> */}
            <Modal
                show={show}
                size="lg"
                centered
                className="delete-video-modal"
            >   
                <Modal.Body className="delete-video-modal-body">
                    <h2 className="delete-video-header">Delete Video</h2>
                    <p className="delete-video-content">The video to be deleted might have been used in slides.Are you sure ?</p>
                    <p className="delete-video-type">{deleteVideoData?.name}</p>
                </Modal.Body>
                <Modal.Footer className="delete-video-footer popupFooter">
                     <Button
                        className="delete-video-cancel-btn"
                        type="button"
                        onClick={() => deleteVideoHandler('No')}
                    >
                        NO
                    </Button>
                    <Button
                        className="delete-video-delete-btn"
                        type="button"
                        onClick={() => deleteVideoHandler('Yes')}
                    >
                        YES, DELETE
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DeleteVideoModal;